function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Q10cover"
}, /*#__PURE__*/React.createElement("path", {
  d: "M480.1,166.4c-3.8-11.3-10-30.3-13.4-60.5c-3.4-30.3-8.1-34.1-9.8-35.2c-1.6-1-13.3-35.7-16.4-37.6 c-3.1-1.9-24.7-14.6-38.4-14.8c-13.7-0.2-13.3,7.8-10,7.4c3.3-0.4,6.1-0.8,14.5,2.3c8.4,3.1,11.4,8.9,19.1,17.1 c7.7,8.2,7,30.5,8.5,42.6c1,8.2-8.7,3-8.7,3l-24.9,7.4c0,0-0.9,34.6,14.4,46.2c7.7,5.8,21.4,21.2,24.9,36.5s3.3,19.1,3.3,19.1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M234.4,166.4c3.8-11.3,10-30.3,13.4-60.5s8.1-34.1,9.8-35.2c1.6-1,13.3-35.7,16.4-37.6c3.1-1.9,24.7-14.6,38.4-14.8 c13.7-0.2,13.3,7.8,10,7.4c-3.3-0.4-6.1-0.8-14.5,2.3c-8.4,3.1-11.4,8.9-19.1,17.1c-7.7,8.2-8.2,30.4-8.5,42.6s10.7,9.9,10.7,9.9 l19.8,20.1c0,0-4.1,20.2-11.3,26.6c-7.2,6.4-21.4,21.2-24.9,36.5s-3.3,19.1-3.3,19.1"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Q10controller"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M329.1,30.1c1.4,1.9,8.9,18.4,10.7,21.8c1.5,2.8,13.9,2.5,17.4,2.5s15.9,0.4,17.4-2.5 c1.8-3.4,9.3-19.9,10.7-21.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M341.8,82.1h-5.1V77c0-1.3-0.9-2.6-2.2-2.9c-1.9-0.4-3.6,1-3.6,2.8v5.2h-5.1c-1.3,0-2.6,0.9-2.9,2.2 c-0.4,1.9,1,3.6,2.8,3.6h5.2V93c0,1.3,0.9,2.6,2.2,2.9c1.9,0.4,3.6-1,3.6-2.8v-5.2h5.2c1.8,0,3.2-1.7,2.8-3.6 C344.4,83,343.1,82.1,341.8,82.1z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 314.8,
  cy: 57.2,
  r: 13.5
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M387,29.2l1.2-2.9c0,0,5.3-1.5,13.4,0.5s10.8,6.2,10.8,6.2v3.1"
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 397.2,
  cy: 43.7,
  r: 5.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st3",
  cx: 397.2,
  cy: 67.6,
  r: 5.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 379.1,
  cy: 84.5,
  r: 11.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 314.8,
  cy: 56.3,
  r: 9.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st4",
  cx: 409.3,
  cy: 56.3,
  r: 5.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st5",
  cx: 385.4,
  cy: 56.3,
  r: 5.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 379.1,
  cy: 85.3,
  r: 14.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 333.9,
  cy: 84.5,
  r: 13.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st6",
  cx: 357.3,
  cy: 46.9,
  r: 3.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 370.2,
  cy: 58.3,
  r: 2.1
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M282.7,95.8c4.7-23.5,13.3-51.2,17.3-57.2c6.1-9.1,17.5-11.1,23.9-10.6c6.4,0.5,13,10.6,21.4,10.6 c3.1,0,11.9,0,11.9,0s8.8,0,11.9,0c8.4,0,15.1-10.1,21.4-10.6c6.4-0.5,17.8,1.5,23.9,10.6c3.8,5.7,11.8,31,16.6,53.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M404,125.8c-1.6-1.2-3.1-2.4-4.6-3.7c-14.8-12.5-23.8-14.3-42.1-14.3s-27.3,1.8-42.1,14.3 c-2.2,1.9-4.5,3.6-6.8,5.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M327.5,29.2l-1.2-2.9c0,0-5.3-1.5-13.4,0.5S302.1,33,302.1,33v3.1"
}), /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 344.3,
  cy: 58.3,
  r: 2.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 357.3,
  cy: 46.9,
  r: 6
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M366.2,108c11.7,1.7,21,7.1,27.2,12.4c3.6,3.1,7.4,5.8,11.3,8.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M348.3,108c-11.7,1.7-21,7.1-27.2,12.4c-4.3,3.7-9,7-13.7,9.5"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Q10Hand"
}, /*#__PURE__*/React.createElement("polyline", {
  className: "st7",
  points: "291,97.6 316.8,70.7 329.1,66.9 336.4,71.9 334.8,82.5 310.8,117.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M291,97.6c0,0-10.9,2.4-10.7-9.9s0.8-34.4,8.5-42.6c7.7-8.2,10.7-14,19.1-17.1c8.4-3.1,11.2-2.6,14.5-2.3 c3.3,0.4,3.6-7.7-10-7.4c-13.7,0.2-35.3,12.9-38.4,14.8c-3.1,1.9-14.7,36.6-16.4,37.6c-1.6,1-6.4,4.9-9.8,35.2s-9.7,49.2-13.4,60.5 "
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M310.8,117.8c0,0-4.1,20.2-11.3,26.6c-7.2,6.4-21.4,21.2-24.9,36.5s-3.3,19.1-3.3,19.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M425.5,90.8c0,0,9.7,5.2,8.7-3c-1.5-12.2-0.8-34.4-8.5-42.6c-7.7-8.2-10.7-14-19.1-17.1 c-8.4-3.1-11.2-2.6-14.5-2.3c-3.3,0.4-3.6-7.7,10-7.4c13.7,0.2,35.3,12.9,38.4,14.8c3.1,1.9,14.7,36.6,16.4,37.6 c1.6,1,6.4,4.9,9.8,35.2c3.4,30.3,9.7,49.2,13.4,60.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M400.6,98.2c0,0-0.9,34.6,14.4,46.2c7.7,5.8,21.4,21.2,24.9,36.5s3.3,19.1,3.3,19.1"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Q10clickEffect"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  id: "Q10L8",
  className: "st4",
  x1: 409.3,
  y1: 47.3,
  x2: 409.3,
  y2: 31.2
}), /*#__PURE__*/React.createElement("line", {
  id: "Q10L7",
  className: "st4",
  x1: 403,
  y1: 50,
  x2: 391.6,
  y2: 38.6
}), /*#__PURE__*/React.createElement("line", {
  id: "Q10L6",
  className: "st4",
  x1: 400.4,
  y1: 56.3,
  x2: 384.3,
  y2: 56.3
}), /*#__PURE__*/React.createElement("line", {
  id: "Q10L5",
  className: "st4",
  x1: 403,
  y1: 62.6,
  x2: 391.6,
  y2: 74
}), /*#__PURE__*/React.createElement("line", {
  id: "Q10L4",
  className: "st4",
  x1: 409.3,
  y1: 65.2,
  x2: 409.3,
  y2: 81.3
}), /*#__PURE__*/React.createElement("line", {
  id: "Q10L3",
  className: "st4",
  x1: 415.6,
  y1: 62.6,
  x2: 427,
  y2: 74
}), /*#__PURE__*/React.createElement("line", {
  id: "Q10L2",
  className: "st4",
  x1: 418.3,
  y1: 56.3,
  x2: 434.4,
  y2: 56.3
}), /*#__PURE__*/React.createElement("line", {
  id: "Q10L1",
  className: "st4",
  x1: 415.6,
  y1: 50,
  x2: 427,
  y2: 38.6
})));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "Q10thumb"
}, /*#__PURE__*/React.createElement("polyline", {
  id: "Q10thumb1",
  className: "st7",
  points: "425.5,90.8 421.4,57.8 415,48.8 404.9,49.3 401.6,58.4 400.6,98.2  "
}, /*#__PURE__*/React.createElement("animate", {
  className: "Q10thumb1-fastgo",
  attributeName: "points",
  attributeType: "XML",
  dur: "0.13s",
  begin: "none",
  fill: "freeze",
  to: "425.5,90.8 421.4,57.8 415,48.8 404.9,49.3 401.6,58.4 400.6,98.2",
  from: "425.5,90.8 414.5,61.9 408.1,52.9 398.1,53.4 394.7,62.5 400.6,98.2"
}), /*#__PURE__*/React.createElement("animate", {
  className: "Q10thumb1-fastback",
  attributeName: "points",
  attributeType: "XML",
  dur: "0.1s",
  begin: "0.1s",
  fill: "freeze",
  from: "425.5,90.8 421.4,57.8 415,48.8 404.9,49.3 401.6,58.4 400.6,98.2",
  to: "425.5,90.8 414.5,61.9 408.1,52.9 398.1,53.4 394.7,62.5 400.6,98.2"
}), /*#__PURE__*/React.createElement("animate", {
  className: "Q10thumb1-slowgo",
  attributeName: "points",
  attributeType: "XML",
  dur: "0.33s",
  begin: "none",
  fill: "freeze",
  to: "425.5,90.8 421.4,57.8 415,48.8 404.9,49.3 401.6,58.4 400.6,98.2",
  from: "425.5,90.8 414.5,61.9 408.1,52.9 398.1,53.4 394.7,62.5 400.6,98.2"
}), /*#__PURE__*/React.createElement("animate", {
  className: "Q10thumb1-slowback",
  attributeName: "points",
  attributeType: "XML",
  dur: "0.33s",
  begin: "0.33s",
  fill: "freeze",
  from: "425.5,90.8 421.4,57.8 415,48.8 404.9,49.3 401.6,58.4 400.6,98.2",
  to: "425.5,90.8 414.5,61.9 408.1,52.9 398.1,53.4 394.7,62.5 400.6,98.2"
})), /*#__PURE__*/React.createElement("polyline", {
  id: "Q10thumb2",
  className: "st8",
  points: "425.5,90.8 414.5,61.9 408.1,52.9 398.1,53.4 394.7,62.5 400.6,98.2  "
}));

var SvgQ10Svg = function SvgQ10Svg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "Q10svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 714.5 202",
    style: {
      enableBackground: "new 0 0 714.5 202"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQ10Svg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Q10svg.d617a76d.svg";
export { ForwardRef as ReactComponent };